var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalorieIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#A5A6BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30482 4.47227C7.27419 4.43477 7.24707 4.40115 7.22419 4.37152C7.19594 4.33466 7.14958 4.3165 7.1038 4.32437C7.05802 4.33224 7.02039 4.36484 7.00607 4.40902C6.93728 4.61908 6.83265 4.81565 6.69682 4.99002C6.70482 4.49352 6.60644 3.6174 5.88694 3.14552C5.84846 3.12025 5.7992 3.11817 5.75873 3.14012C5.71826 3.16206 5.69313 3.20448 5.69332 3.25052C5.69332 3.66002 5.47394 4.0964 5.09257 4.4474C4.72357 4.78715 3.86619 5.68502 3.87507 6.67965C3.88094 7.33252 4.19482 8.22065 4.98044 8.6389C5.01506 8.65739 5.05634 8.65856 5.09195 8.64205C5.12755 8.62554 5.15333 8.59327 5.16157 8.5549C5.23457 8.28242 5.35486 8.02489 5.51694 7.79402C5.69319 7.51102 5.85982 7.24402 5.87507 6.8704C5.87702 6.82146 5.90737 6.77816 5.95272 6.75965C5.99806 6.74113 6.05005 6.75081 6.08569 6.7844C6.52919 7.20177 6.79044 7.7979 6.85569 8.5199C6.85997 8.56116 6.88444 8.59761 6.92101 8.6172C6.95757 8.63678 7.00148 8.63695 7.03819 8.61765C7.60282 8.31602 8.04644 7.74265 8.11719 6.85702C8.21794 5.5969 7.60119 4.83727 7.30482 4.47227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalorieIcon);
export default __webpack_public_path__ + "static/media/calorie-icon.67f65cb5fa8e97509d9a05f96ab5299f.svg";
export { ForwardRef as ReactComponent };